import sessionStorageService from './sessionStorageService';

/**
 * Files chosen on the product page for a companion job that does not exist yet (envelope
 * print-ready artwork, or a data file) are uploaded immediately via Collaterate.Assets.stageFile
 * and attached to the auto-added companion once the customer reaches the cart.
 *
 * Only the staged file's reservation name has to survive that navigation, so this keeps a small
 * list of {name, reservationName} rather than the file itself. A staged file that is never
 * attached expires server-side, so there is nothing to sweep here.
 */
const STORAGE_KEY = 'companionPendingFiles';

const pendingCompanionFileService = {
    list () {
        const records = sessionStorageService.getStorageItem(STORAGE_KEY);
        return Array.isArray(records) ? records : [];
    },

    add (name, reservationName) {
        const records = pendingCompanionFileService.list();
        records.push({ name, reservationName });
        sessionStorageService.setStorageItem(STORAGE_KEY, records);
    },

    remove (reservationName) {
        sessionStorageService.setStorageItem(
            STORAGE_KEY,
            pendingCompanionFileService.list().filter(record => record.reservationName !== reservationName)
        );
    },

    clear () {
        sessionStorageService.setStorageItem(STORAGE_KEY, []);
    },
};

export default pendingCompanionFileService;
